import PropTypes from "prop-types";
import styled from "styled-components";

import { ButtonStyleProps, sharedButtonStyles } from "./styles";

const Button = styled.button<ButtonStyleProps>`
  ${sharedButtonStyles}

  &:disabled {
    background: #f9b0a6;
  }
`;

Button.propTypes = {
  float: PropTypes.string,
  width: PropTypes.string
};

export default Button;
